import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { fetchJson } from '../api';
export const useProductStore = create()(devtools(immer((set) => ({
    product: {},
    selectedServices: [],
    setSelectedService: (service) => {
        set((state) => {
            const index = state.selectedServices.findIndex((s) => s.id === service.id);
            if (index === -1) {
                state.selectedServices.push(service);
            }
            else {
                state.selectedServices.splice(index, 1);
            }
        });
    },
    set: (product) => {
        set((state) => {
            state.product = product;
        });
    },
}))));
export const getProduct = async (url) => {
    const data = await fetchJson(url);
    return data.data;
};
